export default function TitleName() {
  return (
    <div id="TitleName">
      <h1 id="Name">
        Vinicius Zapalá dos Santos
      </h1>
    </div>
  );
}

